const anchorScroll = () => {
  $('a[href*="#"]').on('click', function () {
    let href = $(this).attr("href");

    if (href.indexOf('#') >= 0) {
      let targetId = href.substr(href.indexOf('#'));
      let target = $(targetId == "#" || targetId == "" ? 'body' : targetId);
      if (target.length && target.offset()) {
        let pos = target.offset().top;

        $("html, body").animate({ scrollTop: pos }, 600, "swing");
      }
    }
  });
};

export { anchorScroll }
